export const AUTHENTICATION = 'AUTH/authentication';
export const LOGIN = 'AUTH/login';
export const LOGOUT = 'AUHT/logout';
export const FORGOT_PASSWORD = 'AUTH/forgot_password';
export const CHANGE_PASSWORD = 'AUTH/change_password';
export const RESET_PASSWORD = 'AUTH/reset_password';
export const SET_PASSWORD = 'AUTH/set_password';
export const PROFILE = 'AUTH/profile';
